import Navigation from './components/Navigation';
import Home from './components/Home';
import About from './components/About';
import HowItWorks from './components/HowItWorks';
import Investments from './components/Investments';
import Membership from './components/Membership';
import Contact from './components/Contact';


function App() {
  return (
    <div style={{ minHeight: '100vh', backgroundColor: '#F3F4F6', color: '#1F1F1F', fontFamily: 'Poppins, sans-serif' }}>
      <Navigation />
      <Home />
      <About />
      <HowItWorks />
      <Investments />
      <Membership />
      <Contact />
      
    </div>
  );
}

export default App;